export default __webpack_public_path__ + "c14093cee8c440c1884e38f2a2732bd6.woff";